module.exports = MaterialUI.Chip;